import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_4 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = { class: "text-sm text-gray-500" }
const _hoisted_7 = { class: "mt-5 sm:mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_TailwindDialog = _resolveComponent("TailwindDialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!
  const _component_UserWallet = _resolveComponent("UserWallet")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.co2Title), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.co2Title), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_TransitionRoot, {
            as: "template",
            show: !$setup.hasSeenCo2ChallengeDialog && $setup.isAuthenticated
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TailwindDialog, {
                as: "div",
                class: "relative z-10",
                onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.setHasSeenCo2ChallengeDialog(true)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TransitionChild, {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0",
                    "enter-to": "opacity-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100",
                    "leave-to": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_TransitionChild, {
                        as: "template",
                        enter: "ease-out duration-300",
                        "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                        "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DialogPanel, { class: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_4, [
                                  _createVNode(_component_DialogTitle, {
                                    as: "h3",
                                    class: "text-base font-semibold leading-6 text-gray-900"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.co2DialogTitle), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("p", _hoisted_6, _toDisplayString($setup.co2DialogDescription), 1)
                                  ]),
                                  _createVNode(_component_ion_img, {
                                    class: "w-full h-full",
                                    src: $setup.firstTimeCo2Animation,
                                    alt: 'test'
                                  }, null, 8, ["src"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.setHasSeenCo2ChallengeDialog(true)))
                                }, _toDisplayString($setup.co2DialogBackButton), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_UserWallet, { "wallet-type": $setup.co2EmissionWallet }, null, 8, ["wallet-type"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}